import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-427e3153"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ip-dialog"
};
const _hoisted_2 = {
  class: "page word-break-word2"
};
const _hoisted_3 = {
  key: 0,
  class: "header"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "Attention", -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text2"
}, [/*#__PURE__*/_createTextVNode(" Security services are being upgraded."), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" Stay tuned! ")], -1));
const _hoisted_7 = {
  key: 1,
  class: "text"
};
const _hoisted_8 = {
  key: 2,
  class: "text"
};
import { ref, onMounted } from "vue";
import { getCountry } from "@/service/cf-api.js";
export default {
  __name: 'index',
  setup(__props) {
    const isShowSheet = ref(false);
    const status = ref("");

    // isShowSheet.value = true;
    // status.value = 3;

    onMounted(() => {
      ip();
    });
    function ip() {
      getCountry("/country").then(res => {
        if (res && res.country && res.country == "CN") {
          isShowSheet.value = true;
          status.value = 2;
        }
      }).catch(() => {});
    }
    function onConfirm(type) {
      isShowSheet.value = false;
      if (type) {
        window.location.href = process.env.VUE_APP_IP_COUNTRY_HTML_URL + "/html/restriction.html";
      }
    }
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_van_button = _resolveComponent("van-button");
      const _component_my_van_dialog = _resolveComponent("my-van-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_my_van_dialog, {
        className: "my-ip-dialog",
        show: isShowSheet.value,
        showConfirmButton: false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [status.value != 3 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass(['main', {
            main2: status.value == 3
          }])
        }, [status.value == 3 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_svg_icon, {
          "icon-class": "icon-safety",
          class: "icon"
        }), _hoisted_6], 64)) : _createCommentVNode("", true), status.value == 1 ? (_openBlock(), _createElementBlock("p", _hoisted_7, " The products and services on this website are not intended for individuals in China. Nothing on this website is intended to be construed as a solicitation of any individual in China. ")) : _createCommentVNode("", true), status.value == 2 ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Sorry, due to local laws, you have been blocked. You are unable to access Game.com. ")) : _createCommentVNode("", true), status.value == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 3
        }, [_createVNode(_component_van_button, {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = $event => onConfirm())
        }, {
          default: _withCtx(() => [_createTextVNode("Understand")]),
          _: 1
        }), _createElementVNode("p", {
          class: "cancel",
          onClick: _cache[1] || (_cache[1] = $event => onConfirm(1))
        }, "Cancel")], 64)) : _createCommentVNode("", true)], 2)])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};